module.exports = __webpack_public_path__ + "img/ae-gif-4.0dcaa40.gif";